<app-loading *ngIf="!contentReady"></app-loading>

<main class="doctor-application-page" *ngIf="contentReady" [dir]="isAr ? 'rtl' : 'ltr'">
  <section class="doctor-application-card">
    <div class="page-heading">
      <span>{{ 'applyAny.badge' | transloco }}</span>

      <h1>
        {{
          isUpdatePage
            ? ('applyAny.titleEdit' | transloco)
            : ('applyAny.titleCreate' | transloco)
        }}
      </h1>

      <p>{{ 'applyAny.subtitle' | transloco }}</p>
    </div>

    <form
      [formGroup]="data"
      (ngSubmit)="onSubmit()"
      enctype="multipart/form-data"
      novalidate
    >
      <div class="application-stepper">
        <button
          type="button"
          class="step-pill"
          [class.active]="currentStep === 0"
          [class.done]="currentStep > 0"
          (click)="currentStep = 0"
        >
          <span>1</span>
          {{ 'applyAny.steps.basicData' | transloco }}
        </button>

        <i class="step-line"></i>

        <button
          type="button"
          class="step-pill"
          [class.active]="currentStep === 1"
          [class.done]="currentStep > 1"
          (click)="currentStep >= 1 && (currentStep = 1)"
        >
          <span>2</span>
          {{ 'applyAny.steps.qualifications' | transloco }}
        </button>

        <i class="step-line"></i>

        <button
          type="button"
          class="step-pill"
          [class.active]="currentStep === 2"
          (click)="currentStep >= 2 && (currentStep = 2)"
        >
          <span>3</span>
          {{ 'applyAny.steps.files' | transloco }}
        </button>
      </div>

      <p class="form-message error" *ngIf="formErrorMessage">
        {{ formErrorMessage }}
      </p>

      <div class="server-errors" *ngIf="backendValidationErrors.length">
        <strong>{{ 'applyAny.serverErrorsTitle' | transloco }}</strong>
        <ul>
          <li *ngFor="let err of backendValidationErrors">{{ err }}</li>
        </ul>
      </div>

      <!-- Step 1 -->
      <ng-container *ngIf="currentStep === 0">
        <div class="form-grid">
          <label>
            <span>{{ 'applyAny.fields.name' | transloco }} *</span>
            <input
              type="text"
              formControlName="name"
              [placeholder]="'applyAny.placeholders.name' | transloco"
              [class.is-invalid]="isInvalid('name')"
            />
            <small *ngIf="isInvalid('name')">{{ getError('name') }}</small>
          </label>

          <label>
            <span>{{ 'applyAny.fields.mobile' | transloco }} *</span>
            <input
              type="tel"
              formControlName="mobile"
              [placeholder]="'applyAny.placeholders.mobile' | transloco"
              [class.is-invalid]="isInvalid('mobile')"
            />
            <small *ngIf="isInvalid('mobile')">{{ getError('mobile') }}</small>
          </label>

          <label>
            <span>{{ 'applyAny.fields.email' | transloco }}</span>
            <input
              type="email"
              formControlName="email"
              [placeholder]="'applyAny.placeholders.email' | transloco"
              [class.is-invalid]="isInvalid('email')"
            />
            <small *ngIf="isInvalid('email')">{{ getError('email') }}</small>
          </label>

          <label>
            <span>{{ 'applyAny.fields.residencePlace' | transloco }}</span>
            <input
              type="text"
              formControlName="residence_place"
              [placeholder]="'applyAny.placeholders.residencePlace' | transloco"
              [class.is-invalid]="isInvalid('residence_place')"
            />
            <small *ngIf="isInvalid('residence_place')">
              {{ getError('residence_place') }}
            </small>
          </label>

          <label>
            <span>{{ 'applyAny.fields.birthPlace' | transloco }}</span>
            <input
              type="text"
              formControlName="birth_place"
              [placeholder]="'applyAny.placeholders.birthPlace' | transloco"
              [class.is-invalid]="isInvalid('birth_place')"
            />
            <small *ngIf="isInvalid('birth_place')">
              {{ getError('birth_place') }}
            </small>
          </label>

          <label>
            <span>{{ 'applyAny.fields.birthDate' | transloco }}</span>
            <input
              type="date"
              formControlName="birth_date"
              [placeholder]="'applyAny.placeholders.birthDate' | transloco"
              [class.is-invalid]="isInvalid('birth_date')"
            />
            <small *ngIf="isInvalid('birth_date')">
              {{ getError('birth_date') }}
            </small>
          </label>

          <label>
            <span>{{ 'applyAny.fields.specialty' | transloco }}</span>
            <input
              type="text"
              formControlName="specialty"
              [placeholder]="'applyAny.placeholders.specialty' | transloco"
              [class.is-invalid]="isInvalid('specialty')"
            />
            <small *ngIf="isInvalid('specialty')">{{ getError('specialty') }}</small>
          </label>

          <label>
            <span>{{ 'applyAny.fields.qualification' | transloco }}</span>
            <input
              type="text"
              formControlName="qualification"
              [placeholder]="'applyAny.placeholders.qualification' | transloco"
              [class.is-invalid]="isInvalid('qualification')"
            />
            <small *ngIf="isInvalid('qualification')">{{ getError('qualification') }}</small>
          </label>

          <label>
            <span>{{ 'applyAny.fields.university' | transloco }}</span>
            <input
              type="text"
              formControlName="university"
              [placeholder]="'applyAny.placeholders.university' | transloco"
              [class.is-invalid]="isInvalid('university')"
            />
            <small *ngIf="isInvalid('university')">{{ getError('university') }}</small>
          </label>

          <label>
            <span>{{ 'applyAny.fields.graduationYear' | transloco }}</span>
            <input
              type="number"
              formControlName="graduation_year"
              min="1940"
              max="2100"
              [placeholder]="'applyAny.placeholders.graduationYear' | transloco"
              [class.is-invalid]="isInvalid('graduation_year')"
            />
            <small *ngIf="isInvalid('graduation_year')">
              {{ getError('graduation_year') }}
            </small>
          </label>
        </div>
      </ng-container>

      <!-- Step 2 -->
      <ng-container *ngIf="currentStep === 1">
        <div class="step-two-main-grid">
          <label class="checkbox-field">
            <input type="checkbox" formControlName="has_master" />
            {{ 'applyAny.fields.hasMaster' | transloco }}
          </label>
        </div>

        <div class="degree-fields" *ngIf="data.get('has_master')?.value">
          <h3>{{ 'applyAny.sections.masterDetails' | transloco }}</h3>

          <div class="form-grid">
            <label>
              <span>{{ 'applyAny.fields.masterSource' | transloco }} *</span>
              <input
                type="text"
                formControlName="master_source"
                [placeholder]="'applyAny.placeholders.masterSource' | transloco"
                [class.is-invalid]="isInvalid('master_source')"
              />
              <small *ngIf="isInvalid('master_source')">{{ getError('master_source') }}</small>
            </label>

            <label>
              <span>{{ 'applyAny.fields.masterYear' | transloco }} *</span>
              <input
                type="number"
                formControlName="master_year"
                min="1940"
                max="2100"
                [placeholder]="'applyAny.placeholders.yearExample' | transloco"
                [class.is-invalid]="isInvalid('master_year')"
              />
              <small *ngIf="isInvalid('master_year')">{{ getError('master_year') }}</small>
            </label>
          </div>
        </div>

        <div class="check-grid step-two-check-grid">
          <label>
            <input type="checkbox" formControlName="ksa_experience" />
            {{ 'applyAny.fields.ksaExperience' | transloco }}
          </label>

          <label>
            <input type="checkbox" formControlName="transfer_of_sponsorship" />
            {{ 'applyAny.fields.transferSponsorship' | transloco }}
          </label>

          <label>
            <input type="checkbox" formControlName="visa" />
            {{ 'applyAny.fields.visa' | transloco }}
          </label>
        </div>
      </ng-container>

      <!-- Step 3 -->
      <ng-container *ngIf="currentStep === 2">
        <section class="cv-option upload-image-step">
          <div class="upload-icon" *ngIf="!imagePreviewUrl">
            <span>🖼️</span>
          </div>

          <div class="image-preview-wrap" *ngIf="imagePreviewUrl">
            <img
              class="doctor-preview-img"
              [src]="imagePreviewUrl"
              [alt]="'applyAny.files.selectedImageAlt' | transloco"
            />

            <div>
              <strong>
                {{
                  selectedImage
                    ? selectedImage.name
                    : ('applyAny.files.currentImage' | transloco)
                }}
              </strong>

              <span>
                {{
                  selectedImage
                    ? ('applyAny.files.newImageSelected' | transloco)
                    : ('applyAny.files.currentUploadedImage' | transloco)
                }}
              </span>
            </div>
          </div>

          <strong>{{ 'applyAny.files.imageTitle' | transloco }}</strong>
          <p>{{ 'applyAny.files.imageText' | transloco }}</p>

          <input
            #imageInput
            type="file"
            accept="image/png,image/jpeg,image/jpg,image/webp"
            hidden
            (change)="onImageChange($event)"
          />

          <button type="button" class="upload-button" (click)="imageInput.click()">
            {{
              imagePreviewUrl
                ? ('applyAny.buttons.changeImage' | transloco)
                : ('applyAny.buttons.chooseImage' | transloco)
            }}
            <span>⬆</span>
          </button>

          <button
            *ngIf="selectedImage"
            type="button"
            class="text-button"
            (click)="removeImage()"
          >
            {{ 'applyAny.buttons.removeSelectedImage' | transloco }}
          </button>

          <small *ngIf="imageErrorMessage" class="form-message error">
            {{ imageErrorMessage }}
          </small>
        </section>

        <section class="cv-option">
          <div>
            <strong>{{ 'applyAny.files.certificatesTitle' | transloco }}</strong>
            <p>{{ 'applyAny.files.certificatesText' | transloco }}</p>
          </div>

          <input
            #certificatesInput
            type="file"
            accept=".jpg,.jpeg,.png,.webp,.pdf,image/*,application/pdf"
            multiple
            hidden
            (change)="onCertificatesChange($event)"
          />

          <button
            type="button"
            class="secondary-action"
            (click)="certificatesInput.click()"
          >
            {{
              selectedCertificates.length
                ? ('applyAny.buttons.addMoreFiles' | transloco)
                : ('applyAny.buttons.chooseCertificates' | transloco)
            }}
          </button>

          <button
            *ngIf="selectedCertificates.length"
            type="button"
            class="text-button"
            (click)="clearCertificates()"
          >
            {{ 'applyAny.buttons.removeAllCertificates' | transloco }}
          </button>

          <small *ngIf="certificateErrorMessage" class="form-message error">
            {{ certificateErrorMessage }}
          </small>

          <div class="selected-files" *ngIf="selectedCertificates.length">
            <p>
              {{
                'applyAny.files.selectedFilesCount'
                  | transloco: {
                      count: selectedCertificates.length,
                      max: maxCertificatesCount
                    }
              }}
            </p>

            <div
              class="selected-file-row"
              *ngFor="let file of selectedCertificates; let i = index; trackBy: trackByFile"
            >
              <span>{{ file.name }}</span>

              <button
                type="button"
                class="text-button"
                (click)="removeCertificate(i)"
              >
                {{ 'applyAny.buttons.remove' | transloco }}
              </button>
            </div>
          </div>
        </section>

        <label class="full-width notes-field">
          <span>{{ 'applyAny.fields.notes' | transloco }}</span>
          <textarea
            formControlName="notes"
            rows="4"
            [placeholder]="'applyAny.placeholders.notes' | transloco"
            [class.is-invalid]="isInvalid('notes')"
          ></textarea>
          <small *ngIf="isInvalid('notes')">{{ getError('notes') }}</small>
        </label>
      </ng-container>

      <div class="actions">
        <button
          type="button"
          class="secondary-action"
          (click)="currentStep ? previousStep() : goBack()"
        >
          {{ 'applyAny.buttons.back' | transloco }}
        </button>

        <button
          *ngIf="currentStep < 2"
          type="button"
          class="primary-action"
          (click)="nextStep()"
        >
          {{ 'applyAny.buttons.next' | transloco }}
        </button>

        <button
          *ngIf="currentStep === 2"
          type="submit"
          class="primary-action"
          [disabled]="isSubmitting"
        >
          {{ getSubmitButtonText() }}
        </button>
      </div>
    </form>
  </section>
</main>
